<script lang="ts" setup>
const { useRef } = useLayoutStore()
const [header, rect] = useRef('header')
const [_, sloganrect] = useRef('slogan')

const [root] = useRef('root-container')

const { step, currentColor } = useTyColor({
  0: '#FFE8BB',
  100: '#FFFFFF'
})
const shadow = computed(() => step.value > 90 ? '' : '')

onMounted(() => {
  root.value?.addEventListener('scroll', e => {
    step.value = e.target.scrollTop / sloganrect.height * 100
  })
})

const isIndex = computed(() => useRoute().name === 'index___ja___default')


</script>

<template>
  <ADevice>
    <template #pc>
      <AContainer :wrap-class="`sticky top-0 z-[1000] px-[72px] ${shadow}`" :wrapBg="isIndex ? currentColor : '#fff'"
        ref="header">
        <MRow class=" justify-between py-[29px] border-b border-[#00000033]">
          <ALink to="/">
            <img class=" h-[32px]" src="https://static-jp.theckb.com/static-asset/xr/X&R.svg" alt="">
          </ALink>
          <XrHeaderToolbar :offset="rect.height" :container="root" />
        </MRow>
      </AContainer>
    </template>
    <template #h5>
      <MContainer class=" sticky top-0 z-[1000]" ref="header" :style="{ background: isIndex ? currentColor : '#fff' }"
        :class="shadow">
        <MRow class=" justify-between py-3">
          <ALink to="/">
            <img class="h-[24px]" src="https://static-jp.theckb.com/static-asset/xr/X&R.svg" alt="">
          </ALink>
          <XrHeaderToolbar :offset="rect.height" :container="root" />
        </MRow>
      </MContainer>
    </template>
  </ADevice>
</template>

<style lang="scss" scoped></style>
